export default "__VITE_ASSET__ChvogU_n__"